module.exports = __webpack_public_path__ + "img/AFL_logo_EN_blue.725c7b09.svg";